module.exports = __webpack_public_path__ + "img/flag.5e2fa015.svg";